<template>
  <div>
    <div v-show="!waiverAgreed" style="width: 80%; margin-left: 10%;">
      <a :href="'https://app.mpev.au/members/docs/waiver.pdf'" download="download">Download Waiver</a>
      <v-card>
        <v-card-title>
          <span class="headline">To attend {{trial.trialName}} you must agree to the following waiver.</span>
          <div>
            Please note the requirement for underage participants to bring the waiver to the event,
            signed by a parent or guardian
          </div>
        </v-card-title>
        <v-card-text>
      <div>
<!--        <div v-if="loadedRatio > 0 && loadedRatio < 1" style="background-color: green; color: white; text-align: center" :style="{ width: loadedRatio * 100 + '%' }">{{ Math.floor(loadedRatio * 100) }}%</div>-->
        <pdf v-if="show" ref="pdf" style="border: 1px solid red" :src="src" :page="1" @num-pages="numPages = $event" @link-clicked="page = $event"></pdf>
        <pdf v-if="show" ref="pdf" style="border: 1px solid red" :src="src" :page="2" :rotate="rotate" @num-pages="numPages = $event" @link-clicked="page = $event"></pdf>
      </div>
        </v-card-text>
        <v-card-actions>
        <a :href="'https://app.mpev.au/members/docs/waiver.pdf'" download="download">Download Waiver</a>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="agree">I agree to the waiver above</v-btn>
        </v-card-actions>
      </v-card>
    </div>

  <v-form v-show="waiverAgreed">
    <v-card>
      <v-card-title>
        <span class="headline">Register as Volunteer at trial {{trial.trialName}}</span>
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <div style="align: left">
            <v-row><b>What times are you available?</b></v-row>
          <v-row>
            <v-col cols="12" sm="3">
              <v-checkbox dense v-model="ampm" label="7am - 5pm" @change="avtst"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="2">
              <v-checkbox dense v-model="am" label="7am - 1.30pm" :disabled="ampm"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="2">
              <v-checkbox dense v-model="pm" label="12.30pm - 5pm" :disabled="ampm"></v-checkbox>
            </v-col>
          </v-row>
          </div>
          <v-row><b>Are there any roles you are physically unable to do?</b></v-row>
          <v-row>
            <v-col cols="12" sm="6">
              <v-checkbox dense v-model="notReg" label="Registration Check In - talking & writing"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6"><v-checkbox dense v-model="notTime" label="Timer - using a stop watch"></v-checkbox></v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
            <v-checkbox dense v-model="notVideo" label="Videographer - videoing searches using an iPad, sitting, standing"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6">
            <v-checkbox dense  v-model="notJSteward" label="Judges Steward - talking, writing, walking"></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
            <v-checkbox dense v-model="notGSteward" label="Gate Steward - talking, walking teams from car park to search areas"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6">
            <v-checkbox dense v-model="notBox" label="Box Setter - handling boxes less than 1kg, bending, squatting"></v-checkbox>
              </v-col>
          </v-row>
          <br>

          <v-row>
            <v-col cols="12" sm="12">
              <v-textarea v-model="cmnt" height="5" label="Additional Comments"></v-textarea>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close">Close</v-btn>
        <v-btn color="blue darken-1" text @click="save">Register</v-btn>
      </v-card-actions>

    </v-card>
  </v-form>
    <div id="dummy">
      <iframe id="dummy_frame" style="display:none;"></iframe>
    </div>
  </div>
</template>

<script>

import pdf from 'vue-pdf'

//var loadingTask = pdf.createLoadingTask('https://app.mpev.au/docs/waiver.pdf');

export default {
  components: {
    pdf,
  },
  name: "volreg",
  mounted: function () {
    if (this.$usrStore.token == null) {
      if (localStorage.getItem('token') !== 'undefined') {
        if (localStorage.getItem('token').length > 4) {
          this.$initFromToken(localStorage.getItem('token'))
        }
      }
    }
    this.loadUser()

  },
  data: () => ({
    waiverAgreed: false,
    show: true,
    src:'',
    page: 1,
    numPages: 0,
    rotate: 0,
    pdfList: ['','https://app.mpev.au/members/docs/waiver.pdf'],
    currentPage: 0,
    butNot: '',
    cmnt: '',
    am: false,
    pm: false,
    ampm: true,
    notReg: false,
    notTime: false,
    notVideo: false,
    notJSteward: false,
    notGSteward: false,
    notBox: false,
    agreed: null,
    mbr: {
      type: Object,
      default: {
      }
    }
  }),
  props: {
    trial: {
      type: Object,
      default: null
    },
    member: {
      type: Object,
      default: null
    },
  },
  watch: {
    trial() {
      this.src=this.pdfList[1]
    },
  },
  methods: {
    avtst: function () {
      if(this.ampm) {
        this.am=true
        this.pm=true
      }
    },
    dnld: function () {
      let url = 'https://app.mpev.au/members/docs/waiver.pdf'
      document.getElementById('dummy_frame').src = url
      this.loading = false
    },
    agree: function () {
      this.waiverAgreed = true
      this.agreed = new Date()
    },
    close: function () {
      alert('Exit without completing registration')
      this.$emit('endVolReg', null)
    },
    save: async function () {
      if(this.ampm) {
        this.am=true
        this.pm=true
      }
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.error = this.jsdoc = null
      this.loading = true
      try {
        const resp = await this.$http.post(this.$remote + '/api.trial/addvollie', {
          token: theToken,
          trialId: this.trial.id,
          mbrId: this.mbr.id,
          memberId: this.mbr.id,
          mNbr: this.mbr.mNbr,
          am: this.am,
          pm: this.pm,
          butNot: this.butNot,
          cmnt: this.cmnt,
          notReg: this.notReg,
          notVideo: this.notVideo,
          notTime: this.notTime,
          notJSteward: this.notJSteward,
          notGSteward: this.notGSteward,
          notBox: this.notBox,
          agreed: this.agreed,
        })
        const status = resp.data.validation.status
        if (status == 'ok') {
          alert(`Thank You ${this.mbr.fullName} for volunteering at ${this.trial.trialName}`)
          this.$emit('endVolReg', null)
        }
      } catch (e) {
        alert(e)
      }

      this.$emit('endTrialReg', null)
    },
    loadUser: function () {
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.error = this.jsdoc = null
      this.loading = true
      this.$http.post(this.$remote + '/api/mbr', {
        token: theToken,
        mbrId: this.$usrStore.id
      })
          .then(response => {
            this.mbr = response.data.mbr
            //this.handler = response.data.mbr
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            this.loading = false
          })
          .catch(function (err) {
                if (err.response.data) {
                  alert(err.response.data.msg)
                  window.location.assign('/members')
                } else {
                  alert(err)
                }
              }
          )
    },
  },
  computed: {
    liabilityForm() {
      return `${this.$remote}/w3/waiver.pdf`
    },
    isValid () {
      return (this.selectedDog !== {})
    },
  }
}
</script>
